import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { ToolbarButton } from '@wordpress/components';
import { fullscreen } from '@wordpress/icons';

function BlockFullHeightAlignmentControl(_ref) {
  let {
    isActive,
    label = __('Toggle full height'),
    onToggle,
    isDisabled
  } = _ref;
  return createElement(ToolbarButton, {
    isActive: isActive,
    icon: fullscreen,
    label: label,
    onClick: () => onToggle(!isActive),
    disabled: isDisabled
  });
}

export default BlockFullHeightAlignmentControl;
//# sourceMappingURL=index.js.map